<template>
    <div>
        <div class="mt-4 md:mt-7 pb-5 md:flex md:items-center md:justify-between">
            <h3 class="text-center md:text-left m-0">
                請選擇欲辦理之保單
            </h3>
            <div
                v-if="dataNormal.length + dataWithMemo.length > 0"
                class="hidden md:block toggle-box"
            >
                <SwitchPolicyForm
                    :is-toggle-on="isCardLayout"
                    @click="isCardLayout = !isCardLayout"
                />
            </div>
        </div>
        <div>
            <transition
                name="opacity"
                mode="out-in"
            >
                <div
                    v-if="isCardLayout || isWidthLess780"
                    class="mx-auto max-w-[24.375rem] pad:max-w-full "
                >
                    <transition
                        name="opacity"
                        mode="out-in"
                    >
                        <div
                            v-if="isSkeletonShow"
                            class="pad:grid pad:grid-cols-2 lg:grid-cols-3 pad:gap-x-[1.875rem] pad:mt-3.5"
                        >
                            <SkeletonCardPolicy
                                v-for="i in 3"
                                :key="i"
                            />
                        </div>

                        <div
                            v-else
                            class="pad:grid pad:grid-cols-2 lg:grid-cols-3 pad:gap-[1.875rem]"
                        >
                            <CardPolicy
                                v-for="item in dataNormal"
                                :key="item.id"
                                :investment-obj="item"
                                class="mb-4 last:mb-0 md:mb-0"
                                @click="toServicePage(item)"
                            />
                        </div>
                    </transition>
                </div>
                <TablePolicy
                    v-else
                    :investment-list="dataNormal"
                    @toServicePage="toServicePage"
                />
            </transition>
            <noData
                v-show="data!==null && dataNormal.length === 0"
                class="max-w-[24.375rem] pad:max-w-full mx-auto mt-2"
            >
                您目前沒有任何有效的保單
            </noData>
        </div>
        <div>
            <h4 class="mx-auto max-w-[24.375rem] pad:max-w-full py-[0.9375rem] pad:py-5">
                因相關申請中暫時無法辦理之保單
            </h4>
            <transition
                name="opacity"
                mode="out-in"
            >
                <div
                    v-if="isCardLayout || isWidthLess780"
                    class="mx-auto max-w-[24.375rem] pad:max-w-full"
                >
                    <transition
                        name="opacity"
                        mode="out-in"
                    >
                        <div
                            v-if="isSkeletonShow"
                            class="pad:grid pad:grid-cols-2 lg:grid-cols-3 pad:gap-x-[1.875rem]"
                        >
                            <SkeletonCardPolicy
                                v-for="i in 3"
                                :key="i"
                            />
                        </div>
                        <div
                            v-else
                            class="pad:grid pad:grid-cols-2 lg:grid-cols-3 pad:gap-[1.875rem]"
                        >
                            <CardPolicy
                                v-for="item in dataWithMemo"
                                :key="item.id"
                                :investment-obj="item"
                                class="mb-4 last:mb-0 md:mb-0"
                                disabled
                            />
                        </div>
                    </transition>
                </div>

                <TablePolicy
                    v-else
                    :investment-list="dataWithMemo"
                    disabled
                />
            </transition>
            <noData
                v-if="data!==null && dataWithMemo.length === 0"
                class="max-w-[24.375rem] pad:max-w-full mx-auto mt-2"
            >
                您目前沒有申請中的保單
            </noData>
        </div>
        <ul class="text-tip mt-3 mb-12">
            <li>各基金公司對於短線交易均有規範，若您的交易被基金公司認定為屬短線交易行為，則您可能須承擔由基金公司所收取短線交易費用或遭保留/拒絕本次申購或轉換交易之風險，提醒您避免同一標的頻繁申請轉入轉出交易。</li>
        </ul>
        <Loading :is-loading="isLoading" />
    </div>
</template>
<script>
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import routeName from '@/router/constant.js';
import { useStore } from 'vuex';
import { useEventListener } from '@vueuse/core';
import noData from '@/components/text/EmptyData.vue';
import CardPolicy from './CardPolicy.vue';
import SkeletonCardPolicy from '@/components/skeletons/SkeletonCardPolicy.vue';
import TablePolicy from './TablePolicy.vue';
import SwitchPolicyForm from './SwitchPolicyForm.vue';
import Loading from '@/components/Loading.vue';
import { policyOverview, selectChangedPolicy } from '@/apis/system';

export default {
    name: 'Policy',
    components: {
        noData,
        CardPolicy,
        TablePolicy,
        SwitchPolicyForm,
        SkeletonCardPolicy,
        Loading,
    },
    setup() {
        const router = useRouter();
        const route = useRoute();
        const store = useStore();
        const isLoading = ref(false);
        const isSkeletonShow = ref(false);
        const text = ref(null);
        const isCardLayout = ref(true);
        const isWidthLess780 = ref(window.innerWidth < 780);
        const data = ref(null);
        const dataNormal = ref([]);
        const dataWithMemo = ref([]);
        const isInvenstment = ref(route.name === routeName.POLICY_INVESTMENT);
        const getData = () => {
            isSkeletonShow.value = true;
            // TRADITIONAL=傳統型保單，INVESTMENT_LINKED=投資型保單
            const type = isInvenstment.value ? 'INVESTMENT_LINKED' : 'TRADITIONAL';
            policyOverview(type).then((res) => {
                data.value = res.data?.policyList || [];
                dataNormal.value = data.value.filter(i => i.memo.length === 0);
                dataWithMemo.value = data.value.filter(i => i.memo.length !== 0);
                if (isInvenstment.value) {
                    store.dispatch('policy/setPolicyKindInvestment', 'Y');
                }
            }).finally(() => {
                isSkeletonShow.value = false;
            });
        };
        getData();

        const changeLayout = () => {
            isCardLayout.value = !isCardLayout.value;
        };

        const toServicePage = (item) => {
            isLoading.value = true;
            const requestBody = {
                policyNo: item.policyNo,
                policySeq: item.policySeq,
                idDup: item.idDup,
                srceFrom: item.srceFrom
            };
            selectChangedPolicy(requestBody).then(() => {
                store.dispatch('policy/setPolicy', item);
                router.push({ name: routeName.SERVICE });
            }).finally(() => {
                isLoading.value = false;
            });
        };

        onMounted(() => {
            useEventListener(window, 'resize', (evt) => {
                isWidthLess780.value = window.innerWidth < 780;
            });
        });

        return {
            isCardLayout,
            isWidthLess780,
            changeLayout,
            toServicePage,
            text,
            dataWithMemo,
            isLoading,
            isSkeletonShow,
            dataNormal,
            data
        };
    },

};
</script>
